<template>
  <div >
    <el-form
      class="form"
      size="small"
      label-position="right"
      label-width="100px"
      :rules="rules"
      :model="questionnaireForm"
      ref="questionnaireForm"
    >
      <el-row>
        <el-col>
          <el-form-item label="问卷名称：" prop="questionnaireName">
            <el-input
              v-model="questionnaireForm.questionnaireName"
              placeholder="请输入问卷名称"
              maxlength="50"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item label="问卷说明：" prop="questionnaireDesc">
            <el-input
              v-model="questionnaireForm.questionnaireDesc"
              placeholder="请输入问卷说明"
              type="textarea"
              maxlength="200"
              :rows="2"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <div class="dash-line"></div>
      <el-row>
        <el-col :span="14">
          <el-form-item label="问题列表："></el-form-item>
        </el-col>
        <el-col :span="10">
          <div class="btn-div">
            <el-checkbox
              v-model="dragaable"
              :disabled="dragDisabled"
              class="drag-box mr16"
              >拖拽排序</el-checkbox
            >
            <el-button type="primary" size="small" @click="addQuestion"
              >新增问题</el-button
            >
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item >
            <Table
              :class="{ 'list-drag': dragaable }"
              :data="questionData"
              @deleteQuestion="deleteQuestion"
              @editQuestion="editQuestion"
              :row-key="getRowKey"
            ></Table>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item label-width="0" class="dialog-footer">
            <el-button @click="resetForm">重置</el-button>
            <el-button type="primary" @click="submit">提交</el-button>
            <back-button :pathOptions="pathOptions" :floatLeft="false" />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <QuestionDialog 
      v-if="newDialogInfo.flag"
      :dialogInfo="newDialogInfo"
      @submitAdd="submitAdd"
      @close="closeNewDialog"
     />
  </div>
</template>

<script>

import { Confirm } from "@/components/Confirm";
import BackButton from "@/components/backButton/index.vue";
import { setItem } from "@/utils/storage.js";
import Sortable from "sortablejs";
import { deepClone } from '@/utils/common.js'
import Table from "./table.js";
import QuestionDialog from './newQuestionDialog.vue'

export default {
  components: { Table, BackButton, QuestionDialog },
  props:{
    submitApi: Function,
    defaultForm: Object,
  },
  data() {
    return {
      pathOptions: {
        path: "/questionnaire",
      },
      dragaable: false, //控制拖拽排序,
      questionnaireForm: {
        questionnaireName: "",
        questionnaireDesc: "",
        questions: [],
      },
      questionData: [],
      rules: {
        questionnaireName: [
          { required: true, message: "请输入问卷名称", trigger: "blur" },
          { min: 0, max: 50, message: "最多输入50个字", trigger: "change" },
        ],
        questionnaireDesc: [
          { min: 0, max: 200, message: "最多输入200个字", trigger: "change" },
        ],
      },
      curQuesIdx: -1, //当前操作问题索引
      editQuesFlag: false,
      msgTitle: "新增问题",
      newDialogInfo: {
        flag: false,
      },
      defaultQuestiontForm: {},
    };
  },
  computed: {
    dragDisabled() {
      if (this.questionData.length < 2) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.dragaable = false;
        return true;
      }
      return false;
    },
  },
  created() {
    this.defaultQuestiontForm = deepClone(this.questionnaireForm);
  },
  watch: {
    dragaable(val) {
      this.rowDrop(val);
    },
    defaultForm: {
      handler: function (val) {
        if (val != null) {
          this.initForm(val)
        }
      }
    }
  },
  methods: {

    getRowKey(row) {
      return row.questionTitle + row.uuid || row.questionnaireQuestionType;
    },

    initForm(data) {
      this.defaultQuestiontForm = deepClone(data);
      this.questionnaireForm = data;
      if (this.questionnaireForm.questions.length > 0) {
          this.questionData = JSON.parse(
            JSON.stringify(this.questionnaireForm.questions)
          );
      }
    },

    // 拖拽排序
    rowDrop(flag) {
      if (!flag) {
        // 关闭拖拽功能时销毁Sortable对象
        this.sort && this.sort.destroy();
      } else {
        const _this = this;
        const tbody = document.querySelector(".el-table__body-wrapper tbody");
        this.sort = Sortable.create(tbody, {
          animation: 180,
          delay: 0,
          sort: true,
          draggable: ".el-table__row",

          onEnd({ oldIndex, newIndex }) {
            const currRow = _this.questionData.splice(oldIndex, 1)[0];
            _this.questionData.splice(newIndex, 0, currRow);
          },
        });
      }
    },
    // 新增问题
    submitAdd(item) {
      if (this.editQuesFlag) {
        this.$set(this.questionData, this.curQuesIdx, item);
      } else {
        this.questionData.push(
          item
        );
      }
      this.newDialogInfo = {
        flag: false,
      };
    },

    closeNewDialog() {
      this.newDialogInfo = {
        flag: false,
      };
    },
    
    goback() {
      this.$router.back();
    },

    // 确认新增问题
    addQuestion() {
      if (!this.questionnaireForm.questionnaireName) {
        this.$message({
          message: "请输入问卷名称",
          type: "warning",
        });
        return;
      }
      this.editQuesFlag = false;
      this.newDialogInfo = {
        flag: true,
        isEdit: false,
      }
    },
    
    async resetForm() {
      const text = "确定重置吗?";
      try {
        await Confirm(text, "系统提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        });
        this.questionnaireForm.questionnaireName = this.defaultQuestiontForm.questionnaireName
        this.questionnaireForm.questionnaireDesc = this.defaultQuestiontForm.questionnaireDesc
        if (this.defaultQuestiontForm.questions.length > 0) {
          this.questionData = JSON.parse(JSON.stringify(this.defaultQuestiontForm.questions))
        } else {
          this.questionData = []
        }
        
      } catch (error) {
        if (error === "cancel") return;
      }
    },
    deleteQuestion(vo) {
      this.$confirm(`确认删除选中题目吗？`, "系统提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.questionData.splice(this.questionData.indexOf(vo.row), 1);
        })
        .catch(() => {});
    },
    editQuestion(item) {
      // 是否为编辑转台
      this.editQuesFlag = true;
      // 获取当前编辑的数组index
      this.curQuesIdx = this.questionData.indexOf(item);
      this.newDialogInfo = {
        flag: true,
        isEdit: true,
        question: item
      }
    },
    //新增问卷
    submit() {
      if (!this.submitApi)return;
      this.$refs["questionnaireForm"].validate().then(() => {
        let params = Object.assign({}, this.questionnaireForm);
        params.questions = this.questionData;
        this.submitApi(params).then((res) => {
          if (!res || res.code != 0) return;
          this.$message({
            message: res.msg,
            type: "success",
          });
          setItem(this.REFRESH_FLAG, true);
          this.$router.back();
        });
      });
    },

    
  },
};
</script>

<style lang="scss" scoped>
.btn-div {
  float: right;
  margin-top: 10px;
  .mr16 {
    margin-right: 10px;
  }
}
.dialog-footer {
  text-align: center;
  margin-top: 10px;
}
.dash-line {
  height: 0;
  border-bottom: 1px dashed #e8e8e8;
  margin: 10px 0;
}
/deep/ .el-form-item__label {
  padding: 0 12px 0 0 !important;
}
</style>
